export type FaqAnswerSegment = string | { bold: string };
export type FaqAnswerParagraph = FaqAnswerSegment[];

export interface FaqItem {
  id: string;
  question: string;
  answer: FaqAnswerParagraph[];
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: "changer-contrat",
    question: "Dois-je changer mon contrat d’assurance ?",
    answer: [
      [
        "Non. Le Pack Zéro Franchise complète votre assurance actuelle. Vous n’avez aucune démarche à effectuer auprès de votre assureur principal si ce n’est, d’essayer d’augmenter le montant de vos franchises pour faire baisser votre prime d’assurance annuelle.",
      ],
    ],
  },
  {
    id: "resilier",
    question: "Puis-je résilier facilement ?",
    answer: [
      [
        { bold: "Oui, totalement." },
        " Le Pack Zéro Franchise est ",
        { bold: "sans engagement" },
        " et ",
        { bold: "résiliable à tout moment" },
        ", depuis votre ",
        { bold: "compte personnel" },
        " ou votre application Roole Premium. Aucune démarche complexe, le tout se fait en 3 clics.",
      ],
    ],
  },
  {
    id: "remboursement-an",
    question: "Combien de fois puis-je être remboursé par an ?",
    answer: [
      ["Autant de fois que nécessaire, sans limite."],
      [
        "Exceptions : les événements climatiques et le vol de pièces détachées, chacun limité à une prise en charge par an.",
      ],
    ],
  },
  {
    id: "tiers",
    question: "Puis-je en bénéficier même si je suis assuré(e) au tiers ?",
    answer: [
      ["Le Pack est accessible même avec une assurance au tiers."],
      [
        "Il s’agira dans ce cas d’une aide à la réparation plutôt que d’un remboursement de franchise.",
      ],
      [
        "Tous les événements ne sont toutefois pas couverts : pensez à consulter les conditions générales/détails des garanties.",
      ],
    ],
  },
  {
    id: "sinistres-couverts",
    question: "Quels sinistres sont couverts ?",
    answer: [
      ["Les sinistres couverts dépendent de votre assurance :"],
      [{ bold: "Assurance tous risques (avec franchise)" }, " :"],
      [
        "Accident responsable ou non responsable (sans tiers identifié), vandalisme, incendie, tentative de vol, vol total, choc en stationnement, bris de glace, choc avec un animal sauvage, événement climatique, vol de pièces détachées.",
      ],
      [{ bold: "Assurance au tiers ou sans franchise" }, " :"],
      [
        "Accident responsable, bris de glace, incendie, tentative de vol, vandalisme, vol total.",
      ],
    ],
  },
  {
    id: "delai-carence",
    question: "Y a-t-il un délai de carence ?",
    answer: [
      ["Oui, un délai de carence de 15 jours s’applique."],
      [
        "Pour activer votre protection, vous devez également fournir les photos du véhicule, ainsi que celles du permis de conduire et de la carte grise, comme demandé après la souscription.",
      ],
      ["Ces deux conditions sont requises pour bénéficier d’une prise en charge."],
    ],
  },
  {
    id: "plafond",
    question: "Y a-t-il un plafond ?",
    answer: [["Oui, le plafond est de 500€ par demande de garantie."]],
  },
];
